

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, Watch} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import {IOnOffHandlers} from "bonomo";
import {IErrors} from "@/model/IErrors";
import HelpCard from "@/components/shared/HelpCard.vue";
import {namespace} from "vuex-class";
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
import {IRestrictCellsActionParam} from "@/model/Locker/lockerInterfaces";

const serviceProviderModule = namespace("serviceProviderModule");
const lockerModule = namespace("lockerModule");

@Component({
  name: 'LMServiceProviderRestrictionLine',
  components: {
    HelpCard,
    ServiceProviderChip
  }
})
export default class LMServiceProviderRestrictionLine extends Vue {
  @Prop({default : false})
  private value!: boolean

  @Prop()
  private sp!: IShortServiceProvider;

  @Prop({ default: false })
  private disabled!: boolean;

  @Prop({ default: false })
  private outlined!: boolean;


  private created() {
  }

  public beforeDestroy() {

  }

}

